import styled from 'styled-components';

const InputFileWrapper = styled.div`
  display: none;
`;

export default InputFileWrapper;
